import { create } from 'zustand'
import { persist } from "zustand/middleware"
import steps from "../Steps";
import * as R from "ramda";
import { contactsFormState } from "./contactsFormState";
import { informationFormState } from "./informationFormState";
import { usageFormState } from "./usageFormState";
import { extrasFormState } from "./extrasFormState";
import { fetchFromLocalStorage } from "../lib/utils/localStorage";

const additionalFormDataState = set => ({
  additionalFormData: {},
  setAdditionalFormData: data => set({ additionalFormData: data }),
})

const wizardState = set =>  ({
  currentStep: steps[0],
  resetCurrentStep: () => set({ currentStep: steps[0] }),
  setCurrentStep: name => set({ currentStep: name }),
})

const wizardSuccessState = set =>  ({
  successSteps: [],
  resetSuccessSteps: () => set({ successSteps: [] }),
  addSuccessSteps: name => set(state => ({ successSteps: [name, ...state.successSteps] })),
  removeSuccessSteps: name => set(state => ({ successSteps: R.without([name], state.successSteps) })),
})

const stopLoadLangState = set =>  ({
  stopLoadLanguage: null,
  setStopLoadLanguage: lang => set({ stopLoadLanguage: lang }),
})

const alertState = set =>  ({
  alert: null,
  resetAlert: () => set({ alert: null }),
  setAlert: ({ title, body, type= 'warning' }) => set({ alert: { title, body, type }}),
})

const tokenState = set => ({
  token: null,
  tokenFlag: false,
  resetToken: () => set({ token: null }),
  setToken: (value) => set({ token: value }),
  setTokenFlag: (value) => set({ tokenFlag: value }),
})

const iframeState = set => ({
  iframe: false,
  iframeData: null,
  setIframe: (value) => set({ iframe: value }),
  setIframeData: (value) => set({ iframeData: value }),
})

const stageingState = set => ({
  staging: false,
  setStaging: (value) => set({ staging: value }),
})

const buildInitialState = (set) =>
  ({
    ...wizardState(set),
    ...wizardSuccessState(set),
    ...stopLoadLangState(set),
    ...alertState(set),
    ...contactsFormState(set),
    ...informationFormState(set),
    ...usageFormState(set),
    ...extrasFormState(set),
    ...tokenState(set),
    ...iframeState(set),
    ...stageingState(set),
    ...additionalFormDataState(set),
  })

const useStore = create(persist(
  (set) => buildInitialState(set),
  {
    name: 'policy-data-v2'
  }
  )
);

export const loadInitialState = (outerData = null, name = null, defaultValue = null) => {
  if(name) {
    useStore.persist.setOptions({name: `policy-data-${name}`})
  }

  if(outerData) {
    useStore.setState(R.mergeDeepRight(useStore.getState(), outerData))
  } else {
    if(name) {
      const data = fetchFromLocalStorage(`policy-data-${name}`)
      if(data && data.state) {
        useStore.setState(R.mergeDeepRight(useStore.getState(), data.state))
      } else {
        const clearState = buildInitialState(useStore.setState)
        if(defaultValue && defaultValue.website) {
          clearState.contactsFormValue.website = defaultValue.website
        }
        useStore.setState(clearState, true)
      }
    }
  }
}

export default useStore